export default {
    en: {
        likeThisPost: 'Like this post',
        upVoteThisPost: 'Upvote this post',
        downVoteThisPost: 'Downvote this post',
    },
    in: {
        likeThisPost: 'Sukai postingan ini',
        upVoteThisPost: 'Upvote postingan ini',
        downVoteThisPost: 'Downvote postingan ini',
    },
    zh: {
        likeThisPost: '点赞此帖子',
        upVoteThisPost: '赞成此帖子',
        downVoteThisPost: '反对此帖子',
    },
    nl: {
        likeThisPost: 'Dit bericht leuk vinden',
        upVoteThisPost: 'Dit bericht omhoog stemmen',
        downVoteThisPost: 'Dit bericht omlaag stemmen',
    },
    fi: {
        likeThisPost: 'Tykkää tästä julkaisusta',
        upVoteThisPost: 'Äänestä julkaisua ylöspäin',
        downVoteThisPost: 'Äänestä julkaisua alaspäin',
    },
    fr: {
        likeThisPost: 'Aimer cette publication',
        upVoteThisPost: 'Vote positif',
        downVoteThisPost: 'Vote négatif',
    },
    de: {
        likeThisPost: 'Beitrag liken',
        upVoteThisPost: 'Positiv bewerten',
        downVoteThisPost: 'Negativ bewerten',
    },
    hi: {
        likeThisPost: 'इस पोस्ट को पसंद करें',
        upVoteThisPost: 'इस पोस्ट को अपवोट करें',
        downVoteThisPost: 'इस पोस्ट को डाउनवोट करें',
    },
    it: {
        likeThisPost: 'Metti mi piace al post',
        upVoteThisPost: 'Vota positivamente',
        downVoteThisPost: 'Vota negativamente',
    },
    ja: {
        likeThisPost: 'この投稿にいいね',
        upVoteThisPost: 'この投稿に賛成',
        downVoteThisPost: 'この投稿に反対',
    },
    ko: {
        likeThisPost: '이 게시물 좋아요',
        upVoteThisPost: '게시물 찬성',
        downVoteThisPost: '게시물 반대',
    },
    vi: {
        likeThisPost: 'Thích bài viết này',
        upVoteThisPost: 'Ủng hộ bài viết',
        downVoteThisPost: 'Phản đối bài viết',
    },
    pl: {
        likeThisPost: 'Polub ten post',
        upVoteThisPost: 'Zagłosuj na plus',
        downVoteThisPost: 'Zagłosuj na minus',
    },
    pt: {
        likeThisPost: 'Gostar desta publicação',
        upVoteThisPost: 'Votar a favor',
        downVoteThisPost: 'Votar contra',
    },
    es: {
        likeThisPost: 'Me gusta esta publicación',
        upVoteThisPost: 'Votar a favor',
        downVoteThisPost: 'Votar en contra',
    },
    tr: {
        likeThisPost: 'Bu gönderiyi beğen',
        upVoteThisPost: 'Gönderiyi yukarı oyla',
        downVoteThisPost: 'Gönderiyi aşağı oyla',
    },
    ar: {
        likeThisPost: 'أعجبني هذا المنشور',
        upVoteThisPost: 'التصويت لصالح هذا المنشور',
        downVoteThisPost: 'التصويت ضد هذا المنشور',
    }
};
